// Who a campaign is for (10b, Craig 30 Oct 2026): new firms, firms you know, or both. Kept apart from lib/campaigns.ts
// (the reads and writes) so screens and tests that stand in for those calls still get these.
import type { Campaign, CampaignReach, KnownRule } from "./campaigns";

/** Who a campaign is for; an older database sends none (new firms). */
export const reachOf = (c: Pick<Campaign, "reach">): CampaignReach => c.reach ?? "new";

export const REACH_LABEL: Record<CampaignReach, string> = { new: "New firms", known: "Firms you know", both: "New firms and firms you know" };

/** A new rule's defaults, as the database fills them (crm__known_rule_clean). */
export const KNOWN_RULE_DEFAULTS: KnownRule = { quiet_days: 60, firms: { kind: "all" }, daily_limit: 10 };
